import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from '@src/store/store';
import AuthProvider from './auth/AuthProvider';
import AppContent from './AppContent';
import { AppContextProvider } from './AppContextProvider';
import { ThemeProvider } from './theme/ThemeContext';
import { GlobalOverrides, ThemedConfigProvider } from './theme';

const App = () => {
    return (
        <Provider store={store}>
            <AuthProvider>
                <BrowserRouter>
                    <PersistGate loading={null} persistor={persistor}>
                        <ThemeProvider>
                            <AppContextProvider>
                                <GlobalOverrides />
                                <ThemedConfigProvider>
                                    <AppContent />
                                </ThemedConfigProvider>
                            </AppContextProvider>
                        </ThemeProvider>
                    </PersistGate>
                </BrowserRouter>
            </AuthProvider>
        </Provider>
    );
};

export default App;
